import React, { useState, useEffect } from 'react';
import HospitalsTable from './hospitalsTable';
import constant from '../../constant';

const HospitalsContent = () => {
  const [hospitals, setHospitals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const constructApiUrl = (endpoint) => {
    const userRole = localStorage.getItem("role");
    const adminSelectedUser = localStorage.getItem("adminSelectedUser");
    let apiUrl = `${constant.REACT_APP_API_URL}${endpoint}`;
    if (userRole === "admin" && adminSelectedUser) {
      apiUrl = `${constant.REACT_APP_API_URL}${endpoint}${endpoint.includes("?") ? "&" : "?"
        }userId=${adminSelectedUser}`;
    }
    return apiUrl;
  };

  useEffect(() => {
    const fetchHospitals = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No authentication token found');
        setLoading(false);
        return;
      }

      let apiUrl = constructApiUrl("/hospital/");

      try {
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const result = await response.json();

        if (response.ok) {
          // Map API response to match the expected structure
          const formattedHospitals = result.map(hospital => ({
            _id: hospital.hospital_id,
            name: hospital.name,
            isActive: hospital.is_active,
            createdAt: hospital.created_on,
              streetAddress: hospital.street,
              city: hospital.city,
              state: hospital.state,
              pincode: hospital.pincode,
              country: hospital.country
          }));
          setHospitals(formattedHospitals);
        } else {
          setError(result.message || 'Failed to fetch hospitals');
        }
      } catch (error) {
        setError('Error fetching hospitals');
      } finally {
        setLoading(false);
      }
    };

    fetchHospitals();
  }, []);

  const handleDelete = async (id) => {
    const token = localStorage.getItem('token');
    if (!token) {
      setError('No authentication token found');
      return;
    }

    try {
      const response = await fetch(`${constant.REACT_APP_API_URL}/hospital/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const result = await response.json();
      if (response.ok) {
        // Remove the deleted hospital from state
        setHospitals(hospitals.filter((hospital) => hospital.hospital_id !== id));
      } else {
        setError(result.message || 'Failed to delete hospital');
      }
    } catch (error) {
      setError('Error deleting hospital');
    }
  };

  const handleEdit = (updatedHospital) => {
    setHospitals(hospitals.map((hospital) =>
      hospital._id === updatedHospital._id ? updatedHospital : hospital
    ));
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="px-6 pt-16 md:pt-0">
      <div className="">
        <div className="">
          <HospitalsTable
            hospitals={hospitals}
            onDelete={handleDelete}
            onEdit={handleEdit}
          />
        </div>
      </div>
    </div>
  );
};

export default HospitalsContent;